import request from '@/utils/http';
import utils from '@/utils/common';
const apiCrmHost = 'api-lcrm';

// 客户拜访信息-分页查询-ylx
export const getcustomerVisitListApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/visit/page', // 非权限控制
        method: 'post',
        data
    });
};

// 重点客户分级管理-导出-ylx
export const getListExportApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/visit/export', // 非权限控制
        method: 'post',
        data
    });
};

// 重点客户分级管理 批量启用任务接口-ylx
export const batchEnableApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/visit/start',
        method: 'post',
        data
    });
};
// 客户拜访信息-下载导入模板-ylx
export const visitTemplateDownloadApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/visit/import/download',
        method: 'post',
        responseType: 'blob',
        data
    }).then(res => {
        utils.downloadStream(res, data.fileName);
    });
};
// 客户拜访信息-导入 -ylx
export const getCustomerVisitImport = (data) => {
    return request({
        url: apiCrmHost + '/customer/visit/import',
        method: 'post',
        data
    });
};

// 客户拜访信息-批量删除 -ylx
export const batchDeleteCustomerVisitApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/visit/abandon',
        method: 'post',
        data
    });
};
// 客户拜访信息-保存 -ylx
export const updateCustomerVisit = (data) => {
    return request({
        url: apiCrmHost + '/customer/visit/update',
        method: 'post',
        data
    });
};
// 查询重点客户分级管理详情-保存 -ylx
export const getCustomerVisitDetail = (data) => {
    return request({
        url: apiCrmHost + '/customer/visit/detail',
        method: 'post',
        data
    });
};
// 重点客户分级管理-拜访责任人提交 -ylx
export const submitCustomerVisit = (data) => {
    return request({
        url: apiCrmHost + '/customer/visit/ownerSubmit',
        method: 'post',
        data
    });
};

// 重点客户分级管理-转办接口 -ylx
export const transferCustomerVisitApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/visit/ownerTransfer',
        method: 'post',
        data
    });
};

// 重点客户分级管理-驳回接口 -ylx
export const rejectCustomerVisitApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/visit/ownerReject',
        method: 'post',
        data
    });
};

// 重点客户分级管理-转办日志分页查询 -ylx
export const getTransferLogPageApi = (data) => {
    return request({
        url: apiCrmHost + '/customer/visit/record',
        method: 'post',
        data
    });
};
